// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 656 ? "23e5971a" : chunkId) + "." + {"656":"5a298daec2b9f940","829":"299b7eddb4a3ff60"}[chunkId] + ".js";
};